export const TABLE_HEADER_LABELS = {
  select: '',
  overview: 'Aperçu',
  label: 'Label',
  modificationDate: 'Date de modification',
  actions: 'Actions',
};
